import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import {
  AnnouncementsListComponent,
  AnnouncementFormComponent,
  AnnouncementsReorderComponent,
  InboxComponent,
  InboxMessageComponent
} from '../upgrade/announcements.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard, forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '../upgrade/unsaved.guard';

export const announcementsRoutes: Routes = [
  {
    path: 'announcements',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard],
    data: {
      permission: 'announcements.view'
    },
    children: [
      {
        path: '',
        component: AnnouncementsListComponent,
        data: {
          state: 'epf.announcements.index'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: 'new',
        component: AnnouncementFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'announcements.edit',
          state: 'epf.announcements.new'
        }
      },
      {
        path: 'edit/:id',
        component: AnnouncementFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'announcements.edit',
          state: 'epf.announcements.edit'
        }
      },
      {
        path: 'reorder',
        component: AnnouncementsReorderComponent,
        canActivate: [authGuard, forceOnlineGuard],
        data: {
          permission: 'announcements.edit',
          state: 'epf.announcements.reorder'
        }
      }
    ]
  },
  {
    path: 'inbox',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard],
    children: [
      {
        path: '',
        component: InboxComponent,
        data: {
          state: 'epf.inbox.index'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: ':id',
        component: InboxMessageComponent,
        data: {
          state: 'epf.inbox.view'
        },
        canActivate: [forceOnlineGuard]
      }
    ]
  }
];
